import {WidgetHeaderTitlePart} from '../../widget-header-title';

export const W_HEADER_TITLE_PART_GROUP_SHARED_TYPE = 'GROUP_SHARED';

export interface WHeaderTitlePartGroupSharedData<T> {
    label: string;
    sharedSettingName: string;
    sharedSettingValue: T;
}

export type WHeaderTitlePartGroupShared<T> = WidgetHeaderTitlePart<typeof W_HEADER_TITLE_PART_GROUP_SHARED_TYPE,
    WHeaderTitlePartGroupSharedData<T>>;

export const createWHeaderTitlePartGroupShared = <T>(
    label: string,
    sharedSettingName: string,
    sharedSettingValue: T
): WHeaderTitlePartGroupShared<T> => ({
    type: W_HEADER_TITLE_PART_GROUP_SHARED_TYPE,
    data: {
        label,
        sharedSettingName,
        sharedSettingValue
    }
});
